import SummarySection from './SummarySection';

export default SummarySection;
